<div class="card card-custom" [ngClass]="class" #portlet>
	<ng-content></ng-content>
</div>
